/* eslint-disable */

import { HiX } from "react-icons/hi";
import { Link } from "react-router-dom";
import Links from "./components/Links";

import routes from "routes.js";

const Sidebar = ({ open, onClose }) => {
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex h-screen w-[313px] max-w-[90vw] flex-col overflow-hidden bg-white shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className="shrink-0">
        <div className="mx-[38px] mt-[28px] flex items-center justify-center">
          <Link to="/" aria-label="Home" className="block">
            <img
              src={`${process.env.PUBLIC_URL}/AlphaSniperTradingLogo.png`}
              alt="AlphaSniper Trading"
              className="h-auto w-full max-w-[170px] rounded-lg"
            />
          </Link>
        </div>
        <div className="mx-[38px] mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      </div>

      <nav
        className="min-h-0 flex-1 overflow-y-auto overscroll-y-contain pb-10"
        aria-label="Admin navigation"
      >
        <ul className="pt-1 pr-1">
          <Links routes={routes} />
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
